import {
  AdminSpinner,
  Box,
  Div,
  H3,
  H5,
  Icon,
  P,
  VerticalSeparator,
  centsToDollars,
  formatter,
  lightTheme,
} from '@vgrubs/components';
import {
  NewTransactionResponse,
  vDriveDepositEntity,
  vDriveTransactionEntity,
} from 'components/src/types/api/wallet.types';
import { useState } from 'react';
import { DepositDetailModal } from './DetailModals/DepositDetailModal';
import { TransactionDetailModal } from './DetailModals/TransactionDetailModal';
import { TransactionDateComponent } from './TransactionComponents';
import { IconDeposit, IconTransactions } from './TransactonsStyled';

export const TransactionsVDrive = ({
  transactions,
  sumTransactions,
  type,
  setType,
  loadingSum,
  page,
}: {
  transactions: { date: string; items: NewTransactionResponse[] }[];
  sumTransactions: {
    vDriveDeposits: number;
    vDriveTransactions: number;
    lastVDriveDeposit: number;
    vDriveDepositsReports: number;
    userName: string;
  };
  type: string;
  setType: (type: string) => void;
  loadingSum: boolean;
  page: number;
}) => {
  const [depositModal, setDepositModal] =
    useState<NewTransactionResponse<vDriveDepositEntity> | null>(null);
  const [transactionsModal, setTransactionsModal] =
    useState<NewTransactionResponse<vDriveTransactionEntity> | null>(null);

  return (
    <div>
      <Div $flex $columnSM $gap="20px" $gapSM="16px" $mb="24" $mbSM="16">
        <Box
          $p="16px 24px"
          $flex
          $alignCenter
          $pointer
          $width="50%"
          $widthSM="100%"
          $box={type === 'Deposits'}
          $outlineBox={type !== 'Deposits'}
          onClick={() => setType('Deposits')}
          $relative
          $overflow="hidden"
        >
          {loadingSum && <AdminSpinner absolute small $noZIndex />}
          <Icon>
            <IconDeposit />
          </Icon>
          <VerticalSeparator
            $m="0 20px"
            $mSM="0 16px"
            $h="40px"
            $color={lightTheme.lightGray}
          />
          <Div>
            <H5 $m="0">Total Deposit</H5>
            <H3 $m="0" $color={lightTheme.green}>
              {formatter.format(
                centsToDollars(sumTransactions?.vDriveDeposits)
              )}
            </H3>
            <P $m="0">
              Last Added Deposit:{' '}
              {formatter.format(
                centsToDollars(sumTransactions?.lastVDriveDeposit)
              ) || 0}
            </P>
          </Div>
        </Box>
        <Box
          $p="16px 24px"
          $flex
          $alignCenter
          $width="50%"
          $widthSM="100%"
          $pointer
          $box={type === 'Transactions'}
          $outlineBox={type !== 'Transactions'}
          onClick={() => setType('Transactions')}
          $relative
          $overflow="hidden"
        >
          {loadingSum && <AdminSpinner absolute small $noZIndex />}

          <Icon>
            <IconTransactions />
          </Icon>
          <VerticalSeparator
            $m="0 20px"
            $mSM="0 16px"
            $h="40px"
            $color={lightTheme.lightGray}
          />
          <Div>
            <H5 $m="0">Total Transactions</H5>
            <H3 $m="0" $color={lightTheme.primary}>
              {formatter.format(
                centsToDollars(sumTransactions?.vDriveTransactions)
              )}
            </H3>
            <P $m="0">
              3PD Deposit Reports:{' '}
              <span style={{ color: lightTheme.green }}>
                {formatter.format(
                  centsToDollars(sumTransactions?.vDriveDepositsReports)
                ) || 0}
              </span>
            </P>
          </Div>
        </Box>
      </Div>
      {transactions?.map((item, i) => {
        return (
          <TransactionDateComponent
            item={item}
            index={i}
            key={item.date}
            setDepositModal={setDepositModal}
            setTransactionsModal={setTransactionsModal}
            page={page}
          />
        );
      })}

      <DepositDetailModal
        modalIsOpen={depositModal}
        closeModal={() => setDepositModal(null)}
      />
      <TransactionDetailModal
        modalIsOpen={transactionsModal}
        closeModal={() => setTransactionsModal(null)}
      />
    </div>
  );
};
